import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=36c15700&scoped=true"
import script from "./Audit.vue?vue&type=script&lang=js"
export * from "./Audit.vue?vue&type=script&lang=js"
import style0 from "./Audit.vue?vue&type=style&index=0&id=36c15700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c15700",
  null
  
)

export default component.exports